import React from 'react';
import ok from '../../assets/images/ok.png';

export const ValidateMessage = ({ texte }) => {
    return (
        <div className='flex justify-center my-28 w-full'>
            <div className='text-center'>
                <img className='mx-auto' src={ok} height={80} width={80} alt="" />
                <p className='font-light mt-2  text-sm'>{texte}</p>
            </div>
        </div>
    )
}
